<template>
  <div class="py-4 news_card">
    <div class="news_image">
      <img
        v-show="item.image_url"
        :src="item.image_url"
        :alt="`news-image-${item.title}`"
      />
    </div>
    <div>
      <h4 class="h6" v-text="item.title" />
      <div v-html="item.content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsItem',

  props: {
    item: Object,
    required: true,
  },
};
</script>
